import React from "react";
// import { useNavigate } from "react-router-dom";
// import { ReactComponent as KitchenImage } from "../icons/kitchenImage.svg";
// import { ReactComponent as LocationImage } from "../../icons/locationIcon.svg";

import { ReactComponent as KitchenIcon } from '../../icons/KitchenIcon.svg'
import { ReactComponent as CredentialIcon } from '../../icons/credentialIcon.svg'
import { ReactComponent as OrderIcon } from '../../icons/OrderIcon.svg'
import { ReactComponent as DocumentationIcon } from '../../icons/documentationIcon.svg'
import { ReactComponent as FundingIcon } from '../../icons/fundingIcon.svg'
import { ReactComponent as ExpertIcon } from '../../icons/expertIcon.svg'
// import { ReactComponent as HeartIcon } from "../icons/HeartIcon.svg";
import { ReactComponent as LocationIcon } from "../../icons/locationIcon.svg";
import { ReactComponent as PlanIcon }  from '../../icons/PlanIcon.svg'
import { ReactComponent as RecurrenceIcon } from '../../icons/RecurrenceIcon.svg'

// import { useUpdateAccountDetails } from "../hooks/authhooks";

import { BookedResourceCardProps } from "../../data/types";
import { capitalizeString, capitalizeWords, getBookingStatusColor, getDirectLinkFromGoogleDriveSharedLink, styleThousandCommas } from '../../utils/helpers';
// import moment from "moment";
import moment from 'moment-timezone';
// import { ReactComponent as CalendarIcon } from '../../icons/CalendarIcon.svg';
import { ReactComponent as CalendarIcon } from "../../icons/calendarIconBold.svg";
import { ReactComponent as TimeIcon } from "../../icons/timeIconBold.svg";





const BookedResourceCard: React.FC<BookedResourceCardProps & {
  onViewDetails?: (booking: any) => void;
  onEditDetails?: (booking: any) => void;
}> = ({
  booking,
  // handleRemoveSavedResource,
  isMobile,
  onViewDetails,
  onEditDetails
  // resourceIcon: ResourceIcon,
}) => {

  // const navigate = useNavigate();


  var ResourceIcon = OrderIcon
  const resourceType = booking?.resource_type ? booking.resource_type : ""

  switch(resourceType){
    case 'kitchen':
      ResourceIcon = KitchenIcon
      break;

    case 'documentation':
      ResourceIcon = DocumentationIcon
      break;

    case 'training':
      ResourceIcon = CredentialIcon
      break;

    case 'funding':
      ResourceIcon = FundingIcon
      break;

    case 'expert':
      ResourceIcon = ExpertIcon
      break;

    case 'farm':
      ResourceIcon = OrderIcon
      break;

    default:
      ResourceIcon = OrderIcon
  }


  const getBgColor = () => {
    return "#fff";
  };

  // const getPrimaryTextColor = () => {
  //   return "#202124";
  // };

  // const getSecondaryTextColor = () => {
  //   return "#8A8A8A";
  // };


  // const handleCardClick = async () => {
  //   if (resourceType && booking?.resource_id){
  //     navigate(`/${resourceType}/${booking.resource_id}`)
  //   }
  // }

  // const openInNewTab = (url: string) => {
  //   if (url){
  //     window.open(url, "_blank");
  //   }
  // };

  // var dateFieldName = "Applied"
  // switch(resourceType){
  //   case 'documentation':
  //     dateFieldName = "Submitted On"
  //     break
  //   case 'kitchen':
  //     dateFieldName = "Date"
  //     break
  //   case 'funding':
  //     dateFieldName = "Applied"
  //     break
  //   case 'farm':
  //     dateFieldName = "Ordered On"
  //     break
  //   case 'training':
  //     dateFieldName = "Training Date"
  //     break
  //   case 'expert':
  //     dateFieldName = "Session Date"
  //     break
  //   default:
  //     dateFieldName = "Applied"
  //     break
  // }


  var dateFieldValue = booking.created
  switch(resourceType){
    case 'documentation':
      dateFieldValue = booking.created
      break
    case 'kitchen':
      dateFieldValue = booking.start_time
      break
    case 'funding':
      dateFieldValue = booking.created
      break
    case 'farm':
      dateFieldValue = booking.created
      break
    case 'training':
      dateFieldValue = booking.start_time
      break
    case 'expert':
      dateFieldValue = booking.start_time
      break
    default:
      dateFieldValue = booking.created
      break
  }


  // var buttonName = "Application"
  // switch(resourceType){
  //   case 'documentation':
  //     buttonName = "Submission"
  //     break
  //   case 'kitchen':
  //     buttonName = "Booking"
  //     break
  //   case 'funding':
  //     buttonName = "Application"
  //     break
  //   case 'farm':
  //     buttonName = "Order"
  //     break
  //   case 'training':
  //     buttonName = "Registration"
  //     break
  //   case 'expert':
  //     buttonName = "Appointment"
  //     break
  //   default:
  //     buttonName = "Application"
  //     break
  // }

  var bookingStatusColor: any = getBookingStatusColor(booking?.status ? booking.status : 'pending')
  const bookingStatusBgColor = bookingStatusColor.bgColor
  bookingStatusColor = bookingStatusColor.primaryTextColor


  return (
      <div className={`flex flex-col min-h-[200px] object-cover rounded-xl border-[1px] border-[#E9E9E9] w-full shadow-sm items-center text-start p-4 cursor-pointer bg-gradient-to-a hover:bg-gradient-to-b from-[#f9f9f9] mt-5`} 
          style={{backgroundColor: getBgColor(), opacity: 0.9}} >

          {/* Status Badge */}
          {booking.status && (
            <div
              className="absolute top-5 right-5 px-4 py-1 font-raleway text-[15px] font-bold rounded-md border"
              style={{
                borderColor: bookingStatusColor,
                color: bookingStatusColor,
                backgroundColor: bookingStatusBgColor,
                zIndex: 10,
              }}
            >
              {capitalizeWords(booking.status.replace(/_/g, ' '))}
            </div>
          )}

          <div className='flex flex-col m-2 w-full'>
            <div className='flex flex-row'>
              <div className='p-2 border-[#E9E9E9] w-16 border-[1px] rounded-md mr-auto my-2'>
                {
                  getDirectLinkFromGoogleDriveSharedLink(booking?.resource_logo) ? (
                    <img className=' h-10 aspect-auto object-contain' src={getDirectLinkFromGoogleDriveSharedLink(booking.resource_logo)} alt={booking?.id} /> 
                    ) : (
                      <ResourceIcon className={'relative m-1 w-10 aspect-square p-1 text-[#5DB6CE]/60 '} />
                      )
                }
              </div>
            </div>
              <p 
                className='font-raleway font-bold px-2 text-[18px] my-1 text-primaryDark-0 '
              >
                {booking.resource_name}
              </p>
              <p className='px-2 font-raleway text-[14px] flex flex-row pt-1 text-[#8A8A8A] mb-2'>
                <LocationIcon className="mr-1 my-auto w-4 h-4 text-primaryDark-400" />
                {booking && booking.resource_city ? `${booking.resource_city}, `: ``} 
                {booking && booking.resource_state ? `${booking.resource_state} `: ``}  
                {
                  (booking && 
                    !(booking.resource_city && booking.resource_state)
                  ) ? `Nationwide`: ``
                }
              </p>

              {/* Date and Time */}
              <div className="px-2 font-raleway text-[14px] flex flex-col text-[#1A1A1A] mb-2">
                <span className="inline-flex items-center mb-1">
                  <CalendarIcon className="h-4 w-4 text-primaryDark-400 mr-2" />
                  {moment(dateFieldValue).tz('America/New_York').format('MM/DD/YYYY')}
                </span>
                <span className="inline-flex items-center">
                  <TimeIcon className="h-4 w-4 mr-1 text-primaryDark-400" />
                  {moment(dateFieldValue).tz('America/New_York').format('hh:mma')}
                  {booking.end_time && ` - ${moment(booking.end_time).tz('America/New_York').format('hh:mma')}`}
                </span>
              </div>

              {/* Plan Details */}
              {booking.plan_name && booking.plan_rate && booking.plan_recurrence && (
                <div className="px-2 font-raleway text-[14px] flex flex-col text-[#1A1A1A] mb-4">
                  <span className="inline-flex items-center mb-1">
                    <PlanIcon className="w-4 h-4 mr-2 text-primaryDark-400" />
                    {capitalizeString(booking.plan_name || '')} - ${styleThousandCommas(booking.plan_rate.toString())}
                  </span>
                  <span className="inline-flex items-center">
                    <RecurrenceIcon className="w-5 h-5 mr-1 text-primaryDark-400" />
                    {capitalizeString(booking.plan_recurrence || '')}
                  </span>
                </div>
              )}

              {/* Action Buttons */}
              <div className="flex flex-col w-full gap-2 mt-auto">
                {!(booking.status === 'completed' || booking.status === 'canceled') && (
                  <button
                    className="w-full py-3 text-[#00363A] bg-white border-[1px] border-[#E9E9E9] font-semibold rounded-lg text-[17px] transition-colors duration-200 hover:bg-[#00555A]"
                    onClick={() => onEditDetails && onEditDetails(booking)}
                  >
                    Edit Details
                  </button>
                )}
                <button
                  className="w-full py-3 bg-[#00363A] text-white font-semibold rounded-lg text-[17px] transition-colors duration-200 hover:bg-[#00555A]"
                  onClick={() => onViewDetails && onViewDetails(booking)}
                >
                  View Details
                </button>
              </div>
          </div>
      </div>
      )

};

export default BookedResourceCard;
